import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { KeyRound, ShieldAlert, WifiOff, ArrowRight } from "lucide-react";
import { api } from "../api";

const STATE_META = {
  missing_key: { icon: KeyRound, label: "Credenciais em falta" },
  auth_error: { icon: ShieldAlert, label: "Chave invalida" },
  down: { icon: WifiOff, label: "Sem ligacao" },
};

// Banner de alerta de conectores ativos com falha (chave em falta, auth ou ligacao).
// Usado no topo do Dashboard e do Painel de Plataformas.
export function ConnectorCredentialsBanner() {
  const [alerts, setAlerts] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    let alive = true;
    const load = () =>
      api.get("/connectors/health/alerts")
        .then(({ data }) => { if (alive) setAlerts(data.alerts || []); })
        .catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  return (
    <AnimatePresence>
      {alerts.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }}
          data-testid="connector-credentials-banner"
          className="mb-6 border border-amber-300 bg-amber-50 rounded-lg p-4"
        >
          <div className="flex items-start gap-3">
            <ShieldAlert className="text-amber-600 mt-0.5 shrink-0" size={20} />
            <div className="flex-1 min-w-0">
              <div className="text-amber-800 font-semibold text-sm">
                {alerts.length} conector(es) ativo(s) com problema de credenciais ou ligacao
              </div>
              <ul className="mt-2 space-y-1.5">
                {alerts.map((a) => {
                  const meta = STATE_META[a.state] || STATE_META.down;
                  const Icon = meta.icon;
                  return (
                    <li key={a.connector} data-testid={`connector-alert-${a.connector}`}
                      className="flex items-center gap-2 text-sm">
                      <Icon size={14} className="text-amber-700 shrink-0" />
                      <span className="font-semibold text-amber-900">{a.platform_name}</span>
                      <span className="text-[10px] uppercase tracking-wide font-semibold px-1.5 py-0.5 rounded bg-amber-200 text-amber-800">{meta.label}</span>
                      <span className="text-amber-700 truncate" title={a.error}>{a.error}</span>
                      {a.ui_path && (
                        <button
                          data-testid={`connector-alert-fix-${a.connector}`}
                          onClick={() => nav(a.ui_path)}
                          className="ml-auto shrink-0 inline-flex items-center gap-1 text-xs font-semibold text-amber-800 hover:text-amber-900 underline"
                        >
                          Configurar <ArrowRight size={12} />
                        </button>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ConnectorCredentialsBanner;
